import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DealerProfile } from '@app/domain/model/dealer-profile';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DealerProfileService {

  constructor(private http: HttpClient) {
  }

  /**
   * Returns dealer profile.
   *
   * @param dealerId ID of the dealer, optional if currently logged dealer profile should be read
   */
  getDealerProfile(dealerId?: number): Observable<DealerProfile> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = 'dealers/' + ((null == dealerId) ? 'me' : dealerId) + '/';
    return this.http
      .get(url, { headers: headers })
      .pipe(
        map(response => response ? DealerProfile.fromJSON(response) : null)
      );
  }

}
